import {createPinia} from 'pinia';
import {createApp} from 'vue';
import GuestApp from '@guest/GuestApp.vue';
import router from '@guest/router';
import spellCheckPlugin from '@core/plugins/spellCheckPlugin.ts';
import AppPagination from '@core/components/AppPagination.vue';

const meta = document.createElement('meta');
meta.name = 'naive-ui-style';
document.head.appendChild(meta);

const app = createApp(GuestApp);

document.body.classList.add('bg-gradient-to-br', 'from-slate-400');

app.component('AppPagination', AppPagination);
app.use(router).
  use(createPinia()).
  use(spellCheckPlugin).
  mount('#guest-app');

